<template>
	<div style="background-color:#F8F8F8;">
		<div class="container" style="position: relative; height: 287px;">
			<img class="footbackgroundimg" style="position:absolute;width: 355px;height: 258px;"
				src="../static/水印.png" />
			<div class="row">
				<div class="col-md-7" style="padding-top: 60px; ">
					<div style="padding-bottom: 15px; border-bottom:0.5px solid lightgray;Overflow:visible;  white-space:nowrap;">
						<a style="margin-right: 20px;color: #333333;" @click="gopage('/Supply')"> 供应链服务</a>
						<a style="margin-right: 20px;" @click="gopage('/About')"> 关于我们</a>
						<a style="margin-right: 20px;" @click="gopage('/About/Hr')"> 社会招聘</a>
						<a style="margin-right: 20px;Overflow:visible;  white-space:nowrap;"
							@click="gopage('/Solution/Custom')"> C2M智能定制</a>
					</div>
					<div style="color: gray;margin-top: 45px;">
						24小时联系电话：400-718-0888
					</div>
					<div style="color: gray;margin-top:25px;">
						<a style="margin-right: 40px;"> 邮箱：Fashionlink@xlc2m.com</a>
						<!-- 	<a style="margin-right: 40px;">在线咨询 </a>
						<a style="margin-right: 40px;"> 预约演示</a> -->
					</div>
					<div style="color: #333333;margin-top:25px;">
						<a style="margin-right: 10px;color: #333333;" href="https://beian.miit.gov.cn/">浙ICP备2021038638号
						</a> <a>浙江星链数据科技有限公司 </a>
					</div>
				</div>
				<div class="cc col-md-5" style=" height: 287px; ">
					<div>
						<img class="boxshadow" style="width: 140px;height: 140px;margin-right: 30px;"
							src="../static/数字化订货.png" />
						<img class="boxshadow" style="width: 140px;height: 140px;" src="../static/万利威德.png" />

					</div>

				</div>
			</div>


		</div>
	</div>
</template>

<script>
export default {
	name: 'Pagefoot',
	data() {
		return {

		}
	},
	methods: {


		gopage: function (url) {
			var _this = this
			this.$router.push(url)

			//回到顶部
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
	},

}
</script>

<style>
@media (min-width: 1px) {
	.navtitleicon {}
}

@media (min-width: 900px) {
	.footbackgroundimg {
		margin-left: 65%;
		margin-top: 29px;
	}
}
</style>
